export const sortArrayOfObjects = (input, key, order = 'asc') => {
  // Check if input is an object or an array
  const isObject = typeof input === 'object' && !Array.isArray(input);

  // Convert object to array if input is object
  let array = isObject ? Object.values(input) : input;

  const sorted = array.sort((a, b) => {
    if (a[key] < b[key]) {
      return order === 'asc' ? -1 : 1;
    }
    if (a[key] > b[key]) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  });

  // Convert back to object if the original input was an object
  if (isObject) {
    const result = {};
    sorted.forEach(item => {
      result[item.id] = item;
    });
    return result;
  }

  return sorted;
};
